import { Component, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BasePage } from 'src/pages/base.page';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { LoadingController, ToastController, MenuController, NavController, IonContent } from '@ionic/angular';

import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { FormularioTraderViewModel } from './FormularioTraderViewModel';
import { FormularioTraderModel } from 'projects/core/src/lib/core/model/FormularioTraderModel';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';

@Component({
  selector: 'formulario-trader-page',
  templateUrl: 'formulario-trader.page.html',
  styleUrls: ['formulario-trader.page.scss']
})
export class FormularioTrader extends BasePage {

    @ViewChild(IonContent) content: IonContent;
    
    aba: number = 0
    progress: number = 0

    constructor(
      public router: Router, 
      private loadingController: LoadingController,
      public toastCtrl: ToastController,
      public menuCtrl: MenuController,
      public navCtrl: NavController,
      private activatedRoute: ActivatedRoute) {
      super(router)
    }

    formBuilder: any = {
        "formularios": [
            {
                "id": 1,
                "titulo": "Classificação de conhecimento",
                "nomePasso": "Classificação do conhecimento",
                "subtitulo": "As perguntas abaixo se referem a sua experiência subjetiva, ou seja, como você classifica o seu conhecimento/experiência em relação a cada ítem.",
                "ativo": 1,
                "created_at": null,
                "updated_at": null,
                "itens": []
            },
            {
                "id": 2,
                "titulo": "Escala de Fatores de Estresse do Investidor/Trader nas Operações do Mercado Financeiro",
                "nomePasso": "Fatores de estresse",
                "subtitulo": "Abaixo está uma série de fatores que podem eventualmente lhe causar estresse nas operações do mercado financeiro. Leia cuidadosamente cada um dos fatores, depois coloque o correspondente número no item que indica a intensidade dos fatores enquanto está operando no mercado financeiro.",
                "ativo": 1,
                "created_at": null,
                "updated_at": null,
                "itens": []
            }
        ]
    }

    formBuilderRequest = new FormularioTraderModel()

    listagemIdades = Array.from({length:100},(v,k)=>k+1).filter((i) => i >= 16)
    
    alertComponent: AlertComponent
    loadingComponent: LoadingComponent
    formularioTraderViewModel: FormularioTraderViewModel
    varCheckbox = true
    telaResultado: boolean

    async ngOnInit() {
        this.iniciaVariaveis()
        this.menuCtrl.enable(false)
        this.changeProgress()
        await this.configuraForm()
    }
  
    iniciaVariaveis() {
        if (this.activatedRoute.snapshot.queryParams.telaResultado) {
            this.telaResultado = JSON.parse(this.activatedRoute.snapshot.queryParams.telaResultado);
        }
        this.loadingComponent = new LoadingComponent(this.loadingController)
        this.formularioTraderViewModel = new FormularioTraderViewModel()
        this.formularioTraderViewModel.setContext(this)
    }

    async configuraForm() {
        const loading = await this.showLoading()
        try {
            this.formBuilder.formularios = await this.formularioTraderViewModel.getEstruturaFormulario()
            this.preparaRespostasDefault()
            await this.carregaDadosUsuario()
            await this.iniciaFormnulario()
        } catch (e) {
            this.showAlert("Olá", "Não foi possível acessar a funcionalidade no momento. Tente novamente mais tarde")
            this.fecharTela()
        }
        if (loading != null) {
            loading.dismiss()
        }
    }

    preparaRespostasDefault() {
        if (this.formBuilderRequest.formularios.length <= 0) {
            for (let iForm in this.formBuilder.formularios) {
                this.formBuilderRequest.formularios.push({})
                this.formBuilderRequest.formularios[iForm]["itens"] = []

                for (let iItens in this.formBuilder.formularios[iForm]["itens"]) {
                    if (this.formBuilder.formularios[iForm]["itens"][iItens]["componente"] == "componente_3") {
                        if (this.formBuilderRequest.formularios[iForm]["itens"][iItens] == null) {
                            this.formBuilderRequest.formularios[iForm]["itens"][iItens] = {
                                id: this.formBuilder.formularios[iForm]["itens"][iItens]["id"],
                                value: []
                            }
                        }
                        for (let iOptions in this.formBuilder.formularios[iForm]["itens"][iItens]["opcoes"]) {
                            this.formBuilderRequest.formularios[iForm]["itens"][iItens]["value"][iOptions] = false
                        }
                    } else {
                        this.formBuilderRequest.formularios[iForm]["itens"].push({
                            id: this.formBuilder.formularios[iForm]["itens"][iItens]["id"],
                            value: 0
                        })
                    }
                }
            }
            console.log(this.formBuilderRequest)
        }
    }

    async enviaFormulario() {
        const loading = await this.showLoading()
        try {
            await this.formularioTraderViewModel.enviaFormulario(this.formBuilderRequest)
            this.removeFornularioSessao(false)
            AlertComponent.showAlert("Muito Obrigado!", "Questionário gravado com sucesso!<br/>")
            if (!this.telaResultado) {
                this.fecharTela()
            }
            this.openPage('formulario-trader-resultado')
        } catch (e) {
            AlertComponent.showAlert("Olá", "Erro ao tentar enviar os dados do formulário. Não se preocupe, nós salvamos todas as respostas. Tente novamente", null, [
                {
                    text: 'Cancelar',
                    role: 'cancel',
                    handler: () => {}
                },
                {
                    text: 'Tentar novamente',
                    role: 'tentar-novamente',
                    handler: () => {
                        this.enviaFormulario()
                    }
                }]
            )
        }
        if (loading != null) {
            loading.dismiss()
        }
    }

    showAlert(title: string, message: string) {
        AlertComponent.showAlert(title, message)
    }

    clickItem(indexForm, indexItem, value, event, indexOption = 0) {
        
        console.log(event.target)
        let formsResponse = this.formBuilder.formularios

        
        let formularios = this.formBuilderRequest.formularios
        let dadosUsuario = this.formBuilderRequest.dadosUsuario

        if (formularios[indexForm]["itens"][indexItem] == null) {
            formularios[indexForm]["itens"][indexItem] = {}
        }
        formularios[indexForm]["itens"][indexItem]["id"] = formsResponse[indexForm]["itens"][indexItem]["id"]
        formularios[indexForm]["id"] = formsResponse[indexForm]["id"]

        setTimeout(() => {
            if (formsResponse[indexForm]["itens"][indexItem]["componente"] != "componente_3") {
                formularios[indexForm]["itens"][indexItem]["value"] = value
            }

            let formularioTraderModel = new FormularioTraderModel()
            formularioTraderModel.emAndamento = true
            formularioTraderModel.formularios = formularios
            formularioTraderModel.dadosUsuario = dadosUsuario
        
            AppStorage.set(AppSession.CHAVE_FORMULARIO_TRADER, formularioTraderModel)
            console.log("formsRequest: ", JSON.stringify(formularioTraderModel), formularioTraderModel)
        }, 1000)

        if (formsResponse[indexForm]["itens"][indexItem]["componente"] != "componente_3") {
            setTimeout(() => {
                this.focaNoProximoItem(event.target)
            }, 300)
        }
    }

    verificaCheckboxPorValor(itens, value): boolean {
        itens = itens != null ? itens : []
        return itens.includes(value)
    }

    printItem(value) {
        return JSON.stringify(value)
    }

    focaNoProximoItem(target) {
        let nextElement = target.closest(".questao").nextElementSibling
        if (nextElement && nextElement.classList && nextElement.classList.contains("questao")) {
            let elId = nextElement.id
            let id = parseInt(elId.replace("item_", ""))
            this.focoItemById(id)
        }
    }

    validaFormulario(): Boolean {
        let indexForm = this.getIndexFormularioById(this.aba)
        let itens = this.formBuilderRequest.formularios[indexForm].itens
        for (let i in itens) {
            let itemForm = this.formBuilder.formularios[indexForm].itens[i]
            if (itemForm.condicao_exibir_id) {
                let itemValue = this.getItemFormularioById(itemForm.condicao_exibir_id)
                if (itemValue != null && itemForm.condicao_exibir_value != itemValue.value) {
                    return true
                }
            }

            let ehItemValido = true

            if (itemForm["componente"] == "componente_3") {
                for (let iOptions in itens[i].value) {
                    ehItemValido = itens[i].value[iOptions]
                    if (ehItemValido) break
                }
            } else {
                ehItemValido = itens[i].value != 0
            }

            if (!ehItemValido) {
                let item = this.formBuilder.formularios[indexForm].itens[i]
                this.focoItemById(item.id, true)
                this.showToast("É necessário responder à todas as perguntas")
                return false
            }
        }
        return true
    }

    validaDadosUsuario(): Boolean {
        let chaves = Object.keys(this.formBuilderRequest.dadosUsuario)
        for (let i = 0; i < chaves.length; i++) {
            if (!this.formBuilderRequest.dadosUsuario[chaves[i]]) {
                this.showToast("É necessário preencher todos os campos")
                return false
            }
        }
        return true
    }

    checkCondicaoExibir(itemInput): Boolean {
        let retorno = true
        if (itemInput.condicao_exibir_id) {
            let item = this.getItemFormularioById(itemInput.condicao_exibir_id)
            if (item != null) {
                if (item["value"] != itemInput.condicao_exibir_value) {
                    retorno = false
                } else {
                    retorno = true
                }
            } else {
                retorno = false
            }
        }
        return retorno
    }

    getItemFormularioById(id) {
        let forms = this.formBuilderRequest.formularios
        for (let form of forms) {
            for (let item of form["itens"]) {
                if (item != null && item["id"] == id) {
                    return item
                }
            }
        }
        return null
    }

    async showToast(message: string) {
        let toast = await this.toastCtrl.create({
            message,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    async carregaDadosUsuario() {
        let usuario = await AppSession.getUser()
        this.formBuilderRequest.dadosUsuario.nome = usuario.name
        this.formBuilderRequest.dadosUsuario.email = usuario.email
    }

    focoItemById(id, destaque = false) {
        let el = document.getElementById("item_" + id)
        let offsetTop = el.offsetTop
        this.content.scrollToPoint(0, offsetTop - 10, 500)
        if (destaque) {
            el.classList.add("pulso")
            setTimeout(() => {
                el.classList.remove("pulso")
            }, 3000)
        }
    }

    getIndexFormularioById(id) {
        let forms = this.formBuilder.formularios
        for (let i in forms) {
            if (forms[i].id == id) {
                return i
            }
        }
        return null
    }

    scrollToTop() {
        this.content.scrollToTop(500);
    }

    async iniciaFormnulario() {
        if (this.telaResultado) {
            const loading = await this.showLoading()
            try {
                let formularioTraderModel = await this.formularioTraderViewModel.getRespostasFormulario()
                this.formBuilderRequest.dadosUsuario = formularioTraderModel.dadosUsuario
                this.formBuilderRequest.formularios = formularioTraderModel.formularios

                this.nextPage()
            } catch (e) {
                this.showAlert("Olá", "Não foi possível acessar a funcionalidade no momento. Tente novamente mais tarde")
                this.fecharTela()
            }
            if (loading != null) {
                loading.dismiss()
            }
            
        } else {    
            let formularioTraderModel: FormularioTraderModel = await AppStorage.get(AppSession.CHAVE_FORMULARIO_TRADER)
            if (formularioTraderModel != null) {
                this.formBuilderRequest.dadosUsuario = formularioTraderModel.dadosUsuario
                if (formularioTraderModel.emAndamento) {
                    AlertComponent.showAlert("Olá", "Você já iniciou o preenchimento da pesquisa. Deseja continuar com o preenchimento?", null, [
                        {
                            text: 'Não',
                            role: 'cancel',
                            handler: () => {
                                this.removeFornularioSessao()
                            }
                        },
                        {
                            text: 'Continuar',
                            role: 'continuar',
                            handler: () => {
                                this.formBuilderRequest.formularios = formularioTraderModel.formularios
                                this.nextPage()
                            }
                        }
                    ])
                } else if (!formularioTraderModel.emAndamento) {
                    AlertComponent.showAlert("Olá", "Recebemos a sua solicitação anteriormente. <br/>Deseja editar a pesquisa e reenviar?", null, [
                        {
                            text: 'Editar',
                            role: 'editar-formulario',
                            handler: () => {
                                this.formBuilderRequest.emAndamento = true
                                this.formBuilderRequest.formularios = formularioTraderModel.formularios
                                this.nextPage()
                            }
                        },
                        {
                            text: 'Fechar',
                            role: 'cancel',
                            handler: () => {
                                this.fecharTela()
                            }
                        }
                    ])
                }
            }
        }
    }

    removeFornularioSessao(emAndamento: boolean = true) {
        this.formBuilderRequest.emAndamento = emAndamento
        AppStorage.set(AppSession.CHAVE_FORMULARIO_TRADER, this.formBuilderRequest)
    }

    async showLoading() {
      return await this.loadingComponent.showLoading()
    }

    nextPage() {
        // Dados do usuário
        if (this.aba != 0) {
            if (!this.validaFormulario()) return
        } else {
            if (!this.validaDadosUsuario()) return
        }

        if (this.aba < this.formBuilder.formularios.length) {
            this.aba++
            this.changeProgress()
            this.scrollToTop()
        } else {
            this.btnSend()
        }
    }

    previousPage() {
      if (this.aba >= 1) {
        this.aba--
        this.changeProgress()
      }
    }

    changeProgress() {
      let aux = 1 / (this.formBuilder.formularios.length + 1)
      this.progress = aux * (this.aba + 1)
    }

    fecharTela() {
      this.navCtrl.pop();
    }

    async btnSend() {
      await this.enviaFormulario()
    }
}